import { useDialogForm } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { DataTestId } from '@mews-commander/enums';
import { AssignPropertiesForm } from '../AssignPropertiesForm';

export const useAssignPropertiesForm = () =>
    useDialogForm({
        id: `assign-policy-to-property`,
        title: lt('AssignPropertiesButton'),
        saveLabel: lt('Assign'),
        submitButtonDataTestId: DataTestId.AssignPropertiesSubmitButton,
        renderForm: (props) => <AssignPropertiesForm {...props} />,
    });
